// Mocaverse NFT data
   export const bitBearsNFTs = [
  {
    id: 400,
    name: 'Bit Bears #400',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/400.gif',
    price: '7.23'
  },
  {
    id: 178,
    name: 'Bit Bears #178',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/178.gif',
    price: '6.95'
  },
  {
    id: 1247,
    name: 'Bit Bears #1247',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1247.gif',
    price: '7.42'
  },
  {
    id: 1745,
    name: 'Bit Bears #1745',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1745.gif',
    price: '6.88'
  },
  {
    id: 676,
    name: 'Bit Bears #676',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/676.gif',
    price: '7.15'
  },
  {
    id: 551,
    name: 'Bit Bears #551',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/551.gif',
    price: '7.35'
  },
  {
    id: 2099,
    name: 'Bit Bears #2099',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/2099.gif',
    price: '6.75'
  },
  {
    id: 2166,
    name: 'Bit Bears #2166',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/2166.gif',
    price: '7.48'
  },
  {
    id: 2176,
    name: 'Bit Bears #2176',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/2176.gif',
    price: '7.08'
  },
       {
    id: 2141,
    name: 'Bit Bears #2141',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/2141.gif',
    price: '8.45'
  },
  {
    id: 1827,
    name: 'Bit Bears #1827',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1827.gif',
    price: '7.85'
  },
  {
    id: 1901,
    name: 'Bit Bears #1901',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1901.gif',
    price: '8.15'
  },
  {
    id: 953,
    name: 'Bit Bears #953',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/953.gif',
    price: '8.75'
  },
  {
    id: 654,
    name: 'Bit Bears #654',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/654.gif',
    price: '7.95'
  },
  {
    id: 455,
    name: 'Bit Bears #455',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/455.gif',
    price: '8.35'
  },
  {
    id: 2022,
    name: 'Bit Bears #2022',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/2022.gif',
    price: '8.65'
  },
  {
    id: 1524,
    name: 'Bit Bears #1524',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1524.gif',
    price: '7.75'
  },
  {
    id: 156,
    name: 'Bit Bears #156',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/156.gif',
    price: '8.85'
  },
  {
    id: 1723,
    name: 'Bit Bears #1723',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1723.gif',
    price: '8.25'
  },
  {
    id: 1225,
    name: 'Bit Bears #1225',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1225.gif',
    price: '7.65'
  },
  {
    id: 951,
    name: 'Bit Bears #951',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/951.gif',
    price: '8.55'
  },
  {
    id: 1522,
    name: 'Bit Bears #1522',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1522.gif',
    price: '7.85'
  },
  {
    id: 453,
    name: 'Bit Bears #453',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/453.gif',
    price: '8.15'
  },
  {
    id: 2020,
    name: 'Bit Bears #2020',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/2020.gif',
    price: '8.45'
  },
         {
    id: 1473,
    name: 'Bit Bears #1473',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1473.gif',
    price: '8.25'
  },
  {
    id: 2238,
    name: 'Bit Bears #2238',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/2238.gif',
    price: '7.95'
  },
  {
    id: 1849,
    name: 'Bit Bears #1849',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1849.gif',
    price: '8.65'
  },
  {
    id: 2031,
    name: 'Bit Bears #2031',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/2031.gif',
    price: '7.85'
  },
  {
    id: 1712,
    name: 'Bit Bears #1712',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1712.gif',
    price: '8.35'
  },
  {
    id: 1351,
    name: 'Bit Bears #1351',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1351.gif',
    price: '8.75'
  },
  {
    id: 1622,
    name: 'Bit Bears #1622',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1622.gif',
    price: '7.65'
  },
  {
    id: 1340,
    name: 'Bit Bears #1340',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1340.gif',
    price: '8.15'
  },
  {
    id: 1838,
    name: 'Bit Bears #1838',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1838.gif',
    price: '8.55'
  },
  {
    id: 1533,
    name: 'Bit Bears #1533',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1533.gif',
    price: '7.75'
  },
  {
    id: 2133,
    name: 'Bit Bears #2133',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/2133.gif',
    price: '8.85'
  },
  {
    id: 1214,
    name: 'Bit Bears #1214',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1214.gif',
    price: '8.25'
  },
  {
    id: 962,
    name: 'Bit Bears #962',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/962.gif',
    price: '7.95'
  },
  {
    id: 769,
    name: 'Bit Bears #769',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/769.gif',
    price: '8.45'
  },
  {
    id: 643,
    name: 'Bit Bears #643',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/643.gif',
    price: '8.65'
  },
  {
    id: 780,
    name: 'Bit Bears #780',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/780.gif',
    price: '7.85'
  },
  {
    id: 1510,
    name: 'Bit Bears #1510',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1510.gif',
    price: '8.35'
  },
  {
    id: 1197,
    name: 'Bit Bears #1197',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1197.gif',
    price: '8.75'
  },
  {
    id: 1555,
    name: 'Bit Bears #1555',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1555.gif',
    price: '7.65'
  },
  {
    id: 1424,
    name: 'Bit Bears #1424',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1424.gif',
    price: '8.15'
  },
  {
    id: 1897,
    name: 'Bit Bears #1897',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1897.gif',
    price: '8.55'
  },
  {
    id: 1753,
    name: 'Bit Bears #1753',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1753.gif',
    price: '7.75'
  },
  {
    id: 911,
    name: 'Bit Bears #911',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/911.gif',
    price: '8.85'
  },
  {
    id: 1185,
    name: 'Bit Bears #1185',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1185.gif',
    price: '8.25'
  },
  {
    id: 1922,
    name: 'Bit Bears #1922',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1922.gif',
    price: '7.95'
  },
  {
    id: 853,
    name: 'Bit Bears #853',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/853.gif',
    price: '8.45'
  },
  {
    id: 777,
    name: 'Bit Bears #777',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/777.gif',
    price: '8.65'
  },
  {
    id: 2064,
    name: 'Bit Bears #2064',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/2064.gif',
    price: '7.85'
  },
  {
    id: 994,
    name: 'Bit Bears #994',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/994.gif',
    price: '8.35'
  },
  {
    id: 497,
    name: 'Bit Bears #497',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/497.gif',
    price: '8.75'
  },
  {
    id: 2063,
    name: 'Bit Bears #2063',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/2063.gif',
    price: '7.65'
  },
  {
    id: 1565,
    name: 'Bit Bears #1565',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1565.gif',
    price: '8.15'
  },
  {
    id: 496,
    name: 'Bit Bears #496',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/496.gif',
    price: '8.55'
  },
  {
    id: 1566,
    name: 'Bit Bears #1566',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1566.gif',
    price: '7.75'
  },
  {
    id: 995,
    name: 'Bit Bears #995',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/995.gif',
    price: '8.85'
  },
  {
    id: 1066,
    name: 'Bit Bears #1066',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1066.gif',
    price: '8.25'
  },
  {
    id: 1846,
    name: 'Bit Bears #1846',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1846.gif',
    price: '7.95'
  },
  {
    id: 1869,
    name: 'Bit Bears #1869',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1869.gif',
    price: '8.45'
  },
  {
    id: 800,
    name: 'Bit Bears #800',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/800.gif',
    price: '8.65'
  },
  {
    id: 1075,
    name: 'Bit Bears #1075',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1075.gif',
    price: '7.85'
  },
  {
    id: 2136,
    name: 'Bit Bears #2136',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/2136.gif',
    price: '8.35'
  },
  {
    id: 1067,
    name: 'Bit Bears #1067',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1067.gif',
    price: '8.75'
  },
  {
    id: 684,
    name: 'Bit Bears #684',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/684.gif',
    price: '7.65'
  },
  {
    id: 2058,
    name: 'Bit Bears #2058',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/2058.gif',
    price: '8.15'
  },
  {
    id: 2057,
    name: 'Bit Bears #2057',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/2057.gif',
    price: '8.55'
  },
  {
    id: 2056,
    name: 'Bit Bears #2056',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/2056.gif',
    price: '7.75'
  },
  {
    id: 1806,
    name: 'Bit Bears #1806',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1806.gif',
    price: '8.85'
  },
  {
    id: 1744,
    name: 'Bit Bears #1744',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1744.gif',
    price: '8.25'
  },
  {
    id: 1690,
    name: 'Bit Bears #1690',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1690.gif',
    price: '7.95'
  },
  {
    id: 1680,
    name: 'Bit Bears #1680',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1680.gif',
    price: '8.45'
  },
  {
    id: 1643,
    name: 'Bit Bears #1643',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1643.gif',
    price: '8.65'
  },
  {
    id: 1560,
    name: 'Bit Bears #1560',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1560.gif',
    price: '7.85'
  },
  {
    id: 1559,
    name: 'Bit Bears #1559',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1559.gif',
    price: '8.35'
  },
  {
    id: 1558,
    name: 'Bit Bears #1558',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1558.gif',
    price: '8.75'
  },
  {
    id: 1557,
    name: 'Bit Bears #1557',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1557.gif',
    price: '7.65'
  },
  {
    id: 1246,
    name: 'Bit Bears #1246',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1246.gif',
    price: '8.15'
  },
  {
    id: 1372,
    name: 'Bit Bears #1372',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1372.gif',
    price: '8.55'
  },
  {
    id: 1308,
    name: 'Bit Bears #1308',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1308.gif',
    price: '7.75'
  },
  {
    id: 986,
    name: 'Bit Bears #986',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/986.gif',
    price: '8.85'
  },
  {
    id: 988,
    name: 'Bit Bears #988',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/988.gif',
    price: '8.25'
  },
  {
    id: 987,
    name: 'Bit Bears #987',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/987.gif',
    price: '7.95'
  },
  {
    id: 801,
    name: 'Bit Bears #801',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/801.gif',
    price: '8.45'
  },
  {
    id: 737,
    name: 'Bit Bears #737',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/737.gif',
    price: '8.65'
  },
  {
    id: 675,
    name: 'Bit Bears #675',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/675.gif',
    price: '7.85'
  },
  {
    id: 611,
    name: 'Bit Bears #611',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/611.gif',
    price: '8.35'
  },
  {
    id: 1870,
    name: 'Bit Bears #1870',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1870.gif',
    price: '8.75'
  },
  {
    id: 1182,
    name: 'Bit Bears #1182',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1182.gif',
    price: '7.65'
  },
  {
    id: 2055,
    name: 'Bit Bears #2055',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/2055.gif',
    price: '8.15'
  },
  {
    id: 989,
    name: 'Bit Bears #989',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/989.gif',
    price: '8.55'
  },
  {
    id: 1039,
    name: 'Bit Bears #1039',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1039.gif',
    price: '7.75'
  },
  {
    id: 2108,
    name: 'Bit Bears #2108',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/2108.gif',
    price: '8.85'
  },
  {
    id: 2045,
    name: 'Bit Bears #2045',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/2045.gif',
    price: '8.25'
  },
  {
    id: 1904,
    name: 'Bit Bears #1904',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1904.gif',
    price: '7.95'
  },
  {
    id: 1371,
    name: 'Bit Bears #1371',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1371.gif',
    price: '8.45'
  },
  {
    id: 1451,
    name: 'Bit Bears #1451',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/1451.gif',
    price: '8.65'
  },
  {
    id: 730,
    name: 'Bit Bears #730',
    image: 'https://ipfs.io/ipfs/Qmek1nCGxXmSGj6qq15eyxwkh8CpDN6vc9zrzQpQxAf2nm/730.gif',
    price: '7.85'
  }

    
];
